import React, { useCallback, useState, useEffect } from "react";
import ChatLogo from "@/assets/icons/chat.svg";
import styles from "./styles.module.scss";
import { PrimaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { MONETATE_EVENT_NAMES, trackMonetateEvent } from "@/context/MonetateContext";
import PropTypes from "prop-types";
import OpeningHours from "../contact-details-box/contact-methods/opening-hours/OpeningHours";

function AgentForceChatBotContainer({ open = true, displayTimes }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const onStartSuccessful = () => {
      setIsSubmitting(false);
    };

    window.addEventListener("jl-digital-conversations-chat-started-successfully", onStartSuccessful);
    return () => {
      window.removeEventListener("jl-digital-conversations-chat-started-successfully", onStartSuccessful);
    };
  }, []);

  const dispatchStartEvent = useCallback(event => {
    event.preventDefault();
    setIsSubmitting(true);

    trackMonetateEvent(MONETATE_EVENT_NAMES.AB6017ContactUsDetailsRevealed);

    // Dispatch the custom event to start the chat
    window.dispatchEvent(
      new CustomEvent("jl-AF-conversations-start-chat", {
        detail: {
          channel: "AF-returnsAndRefunds",
        },
      }),
    );
  }, []);

  return (
    <>
      <div className={styles.separator}></div>
      <div className={styles.afchatbotcontainer}>
        <div className={styles.title}>Need help with a return?</div>
        {open ? (
          <>
            <p className={styles.content}>
              Our friendly chatbot is here to support you through the returns and refunds process, or put you in touch
              with one of our agents.
            </p>
            <PrimaryButton submitting={isSubmitting} data-submitting={isSubmitting} onClick={dispatchStartEvent}>
              <img src={ChatLogo.src} alt="" className={styles.icon} />
              Ask our chatbot
            </PrimaryButton>
          </>
        ) : (
          <>
            <p className={styles.content}>Our team is not available for live chat at this time.</p>
            {displayTimes?.length > 0 && (
              <div className={styles.openingTimes}>
                <p className={styles.openingTitle}>
                  <b>Opening times</b>
                </p>
                <OpeningHours openingHours={displayTimes} />
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}

AgentForceChatBotContainer.propTypes = {
  open: PropTypes.bool,
  displayTimes: PropTypes.arrayOf(
    PropTypes.shape({
      order: PropTypes.number,
      days: PropTypes.string,
      times: PropTypes.string,
    }),
  ),
};

export default AgentForceChatBotContainer;
